// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"144":"fafc7e01","787":"65962918"}[chunkId] + ".chunk.css";
};